export const menuPage = [{
  parentName: 'SysModule',
  name: 'Address',
  displayName: '地址管理',
  description: 'M',
  linkUrl: '/Admins/Address/List',
  icon: ''
},
{
  parentName: 'SysModule',
  name: 'Dictionary',
  displayName: '字典管理',
  description: 'M',
  linkUrl: '/Admins/Dictionary/List',
  icon: ''
},
{
  parentName: 'SysModule',
  name: 'User',
  displayName: '账号管理',
  description: 'M',
  linkUrl: '/Admins/User/List',
  icon: ''
},
{
  parentName: 'SysModule',
  name: 'Role',
  displayName: '角色管理',
  description: 'M',
  linkUrl: '/Admins/Role/List',
  icon: ''
},

{
  parentName: 'ReportsModule',
  name: 'Export',
  displayName: '导出任务',
  description: 'M',
  linkUrl: '/Reports/ExportTask/List',
  icon: ''
},
{
  parentName: 'ReportsModule',
  name: 'OrderExport',
  displayName: '订单报表',
  description: 'M',
  linkUrl: '/Reports/OrderExport/List',
  icon: ''
},
{
  parentName: 'BasicModule',
  name: 'Banner',
  displayName: 'Banner管理',
  description: 'M',
  linkUrl: '/Basic/Banner/List',
  icon: ''
},
{
  parentName: 'BasicModule',
  name: 'DealerGroup',
  displayName: '经销商分组',
  description: 'M',
  linkUrl: '/Basic/DealerGroup/List',
  icon: ''
},
{
  parentName: 'BasicModule',
  name: 'Organization',
  displayName: '销售组织',
  description: 'M',
  linkUrl: '/Basic/Organization/List',
  icon: ''
},
{
  parentName: 'BasicModule',
  name: 'Employee',
  displayName: '员工管理',
  description: 'M',
  linkUrl: '/Basic/Employee/List',
  icon: ''
},
{
  parentName: 'OrderModule',
  name: 'Order',
  displayName: '订单管理',
  description: 'M',
  linkUrl: '/Orders/OrderMaster/List',
  icon: ''
},
{
  parentName: 'OrderModule',
  name: 'AuditOrder',
  displayName: '订单审核',
  description: 'M',
  linkUrl: '/Orders/OrderMaster/AuditList',
  icon: ''
},
{
  parentName: 'PromotionModule',
  name: 'Activity',
  displayName: '促销活动',
  description: 'M',
  linkUrl: '/Activity/Activity/List',
  icon: ''
},
{
  parentName: 'PromotionModule',
  name: 'BomProduct',
  displayName: '促销套装',
  description: 'M',
  linkUrl: '/Goods/BomProduct/List',
  icon: ''
},
{
  parentName: 'InformationModule',
  name: 'Announcement',
  displayName: '通知公告',
  description: 'M',
  linkUrl: '/Information/Announcement/List',
  icon: ''
},
{
  parentName: 'InformationModule',
  name: 'Feedback',
  displayName: '反馈信息',
  description: 'M',
  linkUrl: '/Information/Feedback/List',
  icon: ''
},
{
  parentName: 'DealerModule',
  name: 'Credit',
  displayName: '信用管理',
  description: 'M',
  linkUrl: '/Basic/Credit/List',
  icon: ''
},
{
  parentName: 'DealerModule',
  name: 'Dealer',
  displayName: '经销商管理',
  description: 'M',
  linkUrl: '/Basic/Dealer/List',
  icon: ''
},
{
  parentName: 'GoodsModule',
  name: 'ProductCategory',
  displayName: '产品分类',
  description: 'M',
  linkUrl: '/Goods/ProductCategory/List',
  icon: ''
},
{
  parentName: 'GoodsModule',
  name: 'ProductUnion',
  displayName: '产品组合',
  description: 'M',
  linkUrl: '/Goods/ProductUnion/List',
  icon: ''
},
{
  parentName: 'GoodsModule',
  name: 'Product',
  displayName: '产品管理',
  description: 'M',
  linkUrl: '/Goods/Product/List',
  icon: ''
},
{
  parentName: 'GoodsModule',
  name: 'SalesPrice',
  displayName: '价格管理',
  description: 'M',
  linkUrl: '/Goods/SalesPrice/List',
  icon: ''
},
{
  parentName: 'GoodsModule',
  name: 'SalesPriceHistory',
  displayName: '历史价格',
  description: 'M',
  linkUrl: '/Goods/SalesPriceHistory/List',
  icon: ''
},
{
  parentName: 'PromotionModule',
  name: 'PromotionActivity',
  displayName: '促销活动',
  description: 'M',
  linkUrl: '/Promotions/Activity/List',
  icon: ''
},
{
  parentName: 'OrderModule',
  name: 'OrderRule',
  displayName: '订单规则',
  description: 'M',
  linkUrl: '/Orders/OrderRule/List',
  icon: ''
},
{
  parentName: 'OrderModule',
  name: 'DeliveryOrder',
  displayName: '出库单',
  description: 'M',
  linkUrl: '/Orders/DeliveryOrder/List',
  icon: ''
}
  ,
{
  parentName: 'FreightModule',
  name: 'Driver',
  displayName: '司机管理',
  description: 'M',
  linkUrl: '/Freight/Driver/List',
  icon: ''
},
{
  parentName: 'FreightModule',
  name: 'Freight',
  displayName: '运费项目',
  description: 'M',
  linkUrl: '/Freight/Freight/List',
  icon: ''
},
{
  parentName: 'FreightModule',
  name: 'FreightRecord',
  displayName: '运费结算',
  description: 'M',
  linkUrl: '/Freight/Freight/Record',
  icon: ''
},
]

export const modulePage = [{
  icon: 'xitongguanli',
  name: 'SysModule',
  parentName: '',
  displayName: '系统管理',
  submenus: []
},
{
  icon: 'jichushuju3',
  name: 'BasicModule',
  parentName: '',
  displayName: '基础数据',
  submenus: []
},
{
  icon: 'jingxiaoshang',
  name: 'DealerModule',
  parentName: '',
  displayName: '经销商管理',
  submenus: []
},
{
  icon: 'jiaohu1',
  name: 'InformationModule',
  parentName: '',
  displayName: '信息交互',
  submenus: []
},
{
  icon: 'zuhuhoutaiguanlitubiao_-',
  name: 'GoodsModule',
  parentName: '',
  displayName: '产品管理',
  submenus: []
},
{
  icon: 'cuxiaoguanlicopy',
  name: 'PromotionModule',
  parentName: '',
  displayName: '促销管理',
  submenus: []
},
{
  icon: 'dingdanguanli3',
  name: 'OrderModule',
  parentName: '',
  displayName: '订单管理',
  submenus: []
},
{
  icon: 'kongtiaoguankong-',
  name: 'ReportsModule',
  parentName: '',
  displayName: '报表管理',
  submenus: []
},
{
  icon: 'kongtiaoguankong-',
  name: 'FreightModule',
  parentName: '',
  displayName: '运输管理',
  submenus: []
}
]



// WEBPACK FOOTER //
// ./src/config/menuPage.js